import { FlatLookupView } from "@/Common/Api/MedfarDictionaries/Dto/Responses/FlatLookupView";
import { MathHelper } from "@/Common/Helpers/MathHelper";
import { TemperatureUnitsLookup } from "@/Common/Resources/Lookups/Enums/CommonLookupCodes";
import { TemperatureUnit } from "./Units";

export class TemperatureUnitConverter {
    public static convert(from: TemperatureUnit, to: TemperatureUnit, temperature: number, numberOfDecimals?: number): number {
        if (isNaN(temperature) || IsNullOrUndefined(from) || IsNullOrUndefined(to))
            return null;

        let value: number;

        switch (from) {
            case TemperatureUnit.Celsius:
                value = this.convertCelsiusTo(to, temperature);
                break;
            case TemperatureUnit.Fahrenheit:
                value = this.convertFahrenheitTo(to, temperature);
                break;
        }

        return numberOfDecimals ? MathHelper.roundToDecimals(value, numberOfDecimals) : value;
    }

    public static toLookup(unit: TemperatureUnit): FlatLookupView | null {
        switch (unit) {
            case TemperatureUnit.Celsius:
                return cacheStore.FindLookupByLookupCode(TemperatureUnitsLookup.Celcius, TemperatureUnitsLookup.Code);
            case TemperatureUnit.Fahrenheit:
                return cacheStore.FindLookupByLookupCode(TemperatureUnitsLookup.FahrenheitUnit, TemperatureUnitsLookup.Code);
            default:
                throw Error("Not implemented");
        }
    }

    public static convertCelsiusTo(to: TemperatureUnit, temperature: number): number {
        switch (to) {
            case TemperatureUnit.Fahrenheit:
                return this.celsiusToFahrenheit(temperature);
            default:
                return temperature;
        }
    }

    public static convertFahrenheitTo(to: TemperatureUnit, temperature: number): number {
        switch (to) {
            case TemperatureUnit.Celsius:
                return this.fahrenheitToCelsius(temperature);
            default:
                return temperature;
        }
    }

    public static celsiusToFahrenheit(valueInCelsius: number): number {
        return (valueInCelsius * 9 / 5) + 32;
    }

    public static fahrenheitToCelsius(valueInFahrenheit: number): number {
        return (valueInFahrenheit - 32) * 5 / 9;
    }
}
